import { render, staticRenderFns } from "./ChatButtonUniversal.vue?vue&type=template&id=37d82315&scoped=true"
import script from "./ChatButtonUniversal.vue?vue&type=script&lang=js"
export * from "./ChatButtonUniversal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d82315",
  null
  
)

export default component.exports